import React from 'react';

import { flameTheme, Flex } from '@lightspeed/flame/Core';

import { LabelSize, LabelTemplate } from 'label/utils/types';

import { FieldsType, ORIENTATION } from './fieldsTypes';
import LabelOutline from './LabelOutline';

interface RectangleProps {
  width: number;
  height: number;
  top: number;
  left: number;
  style?: React.HTMLAttributes<HTMLOrSVGScriptElement>['style'];
}

const Rectangle = ({ width, height, top, left, style }: RectangleProps): JSX.Element => {
  const { colors } = flameTheme;

  return (
    <rect
      x={top}
      y={left}
      rx="5"
      ry="5"
      width={width}
      height={height}
      fill={colors['gray-100']}
      stroke={colors['gray-100']}
      style={style}
    />
  );
};

export const getIsInvertedAxis = (orientation: ORIENTATION) => [90, 270].includes(orientation);

interface LabelPreviewProps {
  labelTemplate: LabelTemplate;
  labelSize: LabelSize;
}

const LabelPreview = ({ labelTemplate, labelSize }: LabelPreviewProps) => {
  const fields: FieldsType = JSON.parse(labelTemplate?.content).fields;
  const enabledFields = Object.values(fields).filter((field) => field.enabled);

  const renderFieldRectangles = (): JSX.Element[] =>
    enabledFields.map(({ width, height, top, left, orientation, fieldName }) => {
      const isInverted = getIsInvertedAxis(orientation);

      return (
        <Rectangle
          key={fieldName}
          width={isInverted ? height - 2 : width - 2}
          height={isInverted ? width - 2 : height - 2}
          top={left}
          left={top}
        />
      );
    });

  return (
    <Flex justifyContent="center">
      <LabelOutline
        size={labelSize}
        path={renderFieldRectangles()}
        style={{ transform: 'scale(0.5)' }}
      />
    </Flex>
  );
};

export default LabelPreview;
